var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilemedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900",
    width: 900,
    height: 900,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #081e7c } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "logos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m518 62h-437.3c-32.9 0-59.7 26.8-59.7 59.7v580.5c0 32.9 26.8 59.7 59.7 59.7h363.3c-0.8-0.3-1.4-0.7-2.1-1.1-4.4-0.9-8.2-2.4-11.8-4.2-11.8-4.7-20.2-13.3-24.6-24.1h-324.8c-16.8 0-30.4-13.6-30.4-30.3v-580.4c0-16.8 13.6-30.4 30.4-30.4h437.2c16.8 0 30.4 13.6 30.4 30.4v148c6.8-8 16.8-13.5 29.4-15.2v-132.8c0-33-26.8-59.8-59.7-59.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m219.9 384.6c-18.1 0-32.8-14.7-32.8-32.8 0-18.1 14.7-32.7 32.8-32.7 18.1 0 32.8 14.6 32.8 32.7 0 18.1-14.7 32.8-32.8 32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m378.5 384.6c-18.1 0-32.7-14.7-32.7-32.8 0-18.1 14.6-32.7 32.7-32.7 18.2 0 32.8 14.6 32.8 32.7 0 18.1-14.6 32.8-32.8 32.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m299.3 595.8c-70.2 0-132.1-49.8-147.1-118.5-1.4-6.5 2.7-12.9 9.1-14.3 6.4-1.4 12.9 2.7 14.3 9.1 12.7 57.8 64.7 99.7 123.7 99.7 59.1 0 111.1-41.9 123.8-99.7 1.4-6.4 7.8-10.5 14.3-9.1 6.4 1.4 10.5 7.8 9.1 14.3-15 68.7-77 118.5-147.2 118.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m603 232.8l239.7 76.1c27.3 8.7 42.6 38.1 33.9 65.5l-135.8 427.3c-6.9 21.7-26.9 36.4-49.7 36.4-5.3 0-10.6-0.8-15.7-2.5l-239.7-76.1c-27.4-8.7-42.6-38-33.9-65.4l135.7-427.4c7-21.7 26.9-36.3 49.7-36.3 5.3 0 10.6 0.8 15.8 2.4zm-37.8 42.7l-135.8 427.4c-3.8 12.1 2.9 25.1 15.1 29l239.7 76.1c2.3 0.8 4.7 1.1 7 1.1 9.8 0 18.9-6.3 22-16.1l135.7-427.4c3.9-12.2-2.8-25.2-15-29.1l-239.7-76.1c-2.3-0.7-4.7-1-7-1-9.8 0-18.9 6.2-22 16.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m713.1 292.6l-1-0.3-59.5-18.9-0.3 22.3c0 3.8 2.5 7.2 6.1 8.4l45.3 14.4 1.1 0.3 45.3 14.4c3.6 1.2 7.6-0.2 9.8-3.4l12.7-18.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m303.3 282.5c-46.7 0-84.4-37.7-84.4-84.4 0-46.7 37.7-84.4 84.4-84.4 46.6 0 84.3 37.7 84.3 84.4 0 46.7-37.7 84.4-84.3 84.4zm61.7-84.4c0-34.1-27.6-61.7-61.7-61.7-34.2 0-61.7 27.6-61.7 61.7 0 34.1 27.5 61.7 61.7 61.7 34.1 0 61.7-27.6 61.7-61.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m303.3 220.5c-12.4 0-22.4-10-22.4-22.4 0-12.4 10-22.4 22.4-22.4 12.3 0 22.3 10 22.3 22.4 0 12.4-10 22.4-22.3 22.4z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m21 166h212.7v64.2h-212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m370.7 166h207v64.2h-207z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m571.4 515.8c-4.2 0-7.8 3.2-8.3 7.5-3.6 36 18.8 70.3 53.2 81.5 7.8 2.5 15.7 3.7 23.5 3.7q0.1 0 0.2 0c27 0 53.1-14.2 67.3-38.4 2.3-3.9 1-9-2.9-11.3-1.3-0.8-2.8-1.1-4.2-1.1-2.9 0-5.6 1.5-7.1 4.1-11.2 19.1-31.8 30.2-53.1 30.2-6.2 0-12.5-0.9-18.5-2.9-27.1-8.8-44.8-35.7-41.9-64.2 0.4-4.5-2.9-8.5-7.4-9-0.3 0-0.6-0.1-0.8-0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m613.8 467.6c-11.8 0-21.4-9.6-21.4-21.4 0-11.8 9.6-21.4 21.4-21.4 11.8 0 21.4 9.6 21.4 21.4 0 11.8-9.6 21.4-21.4 21.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m712.3 498.2c-11.8 0-21.4-9.5-21.4-21.3 0-11.9 9.6-21.4 21.4-21.4 11.8 0 21.4 9.5 21.4 21.4 0 11.8-9.6 21.3-21.4 21.3z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilemedIcon);
export default __webpack_public_path__ + "static/media/mobilemed-icon.5e78cb19517e0c2fd975ba43b9b99867.svg";
export { ForwardRef as ReactComponent };